import { render, staticRenderFns } from "./OrbitTokenCarousel.vue?vue&type=template&id=7a6b3757&scoped=true"
import script from "./OrbitTokenCarousel.vue?vue&type=script&lang=ts"
export * from "./OrbitTokenCarousel.vue?vue&type=script&lang=ts"
import style0 from "./OrbitTokenCarousel.vue?vue&type=style&index=0&id=7a6b3757&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a6b3757",
  null
  
)

export default component.exports